import { twMerge } from "tailwind-merge";

import FunctionalButton from "./FunctionalButton";

import { ReactComponent as DeleteIcon } from "assets/svgs/Delete.svg";

const DeleteButton = ({
    className = "",
    showIcon = true,
    disabled = false,
    onClick = () => {},
}) => {
    return (
        <FunctionalButton
            className={twMerge(
                "h-6 w-20 rounded-r3 bg-warning px-2 py-1 hover:bg-red-500",
                className
            )}
            title="Delete"
            icon={showIcon && <DeleteIcon />}
            onClick={onClick}
            disabled={disabled}
        />
    );
};

export default DeleteButton;
